/* ==========================================================================
   SAVA — product page
   Gallery, variant selection, quantity stepper, AJAX add-to-cart, accordion.
   ========================================================================== */
(function () {
  'use strict';

  var form = document.querySelector('[data-yv-product-form]');
  if (!form) return; // not a product page

  var section = form.closest('.yv-product');
  var jsonEl = section.querySelector('[data-yv-product-json]');
  var product = null;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    product = null;
  }

  var variantIdInput = form.querySelector('[data-yv-variant-id]');
  var priceEl = section.querySelector('[data-yv-price]');
  var addBtn = form.querySelector('[data-yv-add-to-cart]');
  var addBtnText = form.querySelector('[data-yv-add-to-cart-text]');
  var optionInputs = form.querySelectorAll('[data-yv-option-input]');

  /* ---- Gallery ---- */
  var gallery = section.querySelector('[data-yv-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-yv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-yv-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Variant selection ---- */
  function currentSelection() {
    var selection = [];
    optionInputs.forEach(function (input) {
      if (input.checked) selection[Number(input.getAttribute('data-option-index'))] = input.value;
    });
    return selection;
  }

  function findVariant(selection) {
    if (!product) return null;
    return product.variants.find(function (variant) {
      return variant.options.every(function (opt, i) { return opt === selection[i]; });
    }) || null;
  }

  var currencyCode = jsonEl.getAttribute('data-currency') || 'GBP';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: currencyCode });
  }

  function updateAvailability(selection) {
    optionInputs.forEach(function (input) {
      var idx = Number(input.getAttribute('data-option-index'));
      var testSelection = selection.slice();
      testSelection[idx] = input.value;
      var matches = product.variants.filter(function (variant) {
        return variant.options[idx] === input.value;
      });
      var possible = matches.some(function (variant) {
        return variant.options.every(function (opt, i) {
          return i === idx || testSelection[i] === undefined || opt === testSelection[i];
        });
      });
      input.disabled = !possible;
    });
  }

  /* Keep the "SAGE" / "INK" style label next to each option's heading in
     sync with the currently selected value (used for the color swatch
     row, which hides its own text under the swatches). */
  function updateOptionLabels(selection) {
    form.querySelectorAll('[data-yv-option-index]').forEach(function (group) {
      var idx = Number(group.getAttribute('data-yv-option-index'));
      var labelEl = group.querySelector('[data-yv-option-selected]');
      if (labelEl && selection[idx] !== undefined) labelEl.textContent = selection[idx];
    });
  }

  function onVariantChange() {
    var selection = currentSelection();
    updateAvailability(selection);
    updateOptionLabels(selection);
    var variant = findVariant(selection);

    if (!variant) {
      addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'Unavailable';
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<s>' + formatMoney(variant.compare_at_price) + '</s> <span class="yv-product__price--sale">' + formatMoney(variant.price) + '</span>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    if (variant.featured_image) {
      var mainImgEl = section.querySelector('[data-yv-gallery-main]');
      var src = variant.featured_image.src;
      if (mainImgEl && src) {
        mainImgEl.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
      }
    }

    addBtn.disabled = !variant.available;
    if (addBtnText) {
      addBtnText.textContent = variant.available ? addBtnText.getAttribute('data-label-add') || 'Add to cart' : 'Sold out';
    }
  }

  if (addBtnText && !addBtnText.getAttribute('data-label-add')) {
    addBtnText.setAttribute('data-label-add', addBtnText.textContent.trim());
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', onVariantChange);
  });
  if (optionInputs.length && product) onVariantChange();

  /* Quantity stepper: wired globally for every .yv-qty widget on the page,
     see yvee-motion.js. */

  /* ---- AJAX add to cart ----
     Adds the item, re-renders the cart drawer via the Section Rendering API,
     fires yvee:cart:updated, and opens the drawer. Falls back to a normal
     form submit if the fetch fails (progressive enhancement). */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled) return;

    addBtn.disabled = true;
    var originalText = addBtnText ? addBtnText.textContent : '';
    if (addBtnText) addBtnText.textContent = 'Adding…';

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/?sections=header');
      })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var newDrawer = new DOMParser()
          .parseFromString(sections.header, 'text/html')
          .querySelector('#yv-cart-drawer');
        var currentDrawer = document.querySelector('#yv-cart-drawer');
        if (newDrawer && currentDrawer) currentDrawer.outerHTML = newDrawer.outerHTML;

        document.dispatchEvent(new CustomEvent('yvee:cart:updated'));

        if (addBtnText) { addBtnText.textContent = 'Added to cart'; setTimeout(function () { if (addBtnText.textContent === 'Added to cart') addBtnText.textContent = originalText; }, 2000); }
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        addBtn.disabled = false;
        if (addBtnText && addBtnText.textContent !== 'Added to cart') addBtnText.textContent = originalText;
      });
  });

  /* ---- Accordion ---- */
  section.querySelectorAll('[data-yv-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-yv-accordion-item]');
      var panel = item.querySelector('.yv-accordion__panel');
      var isOpen = item.classList.contains('is-open');

      section.querySelectorAll('[data-yv-accordion-item]').forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('.yv-accordion__panel').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();
